import { render, staticRenderFns } from "./QuestionResult.vue?vue&type=template&id=7fa49560"
import script from "./QuestionResult.vue?vue&type=script&lang=js"
export * from "./QuestionResult.vue?vue&type=script&lang=js"
import style0 from "./QuestionResult.vue?vue&type=style&index=0&id=7fa49560&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports